import styled from "styled-components";

export const Styled = styled.div`
  > span {
    margin-right: 4px;
  }
`;
